import FormResStatus from './form-res-status';
import { ResData } from '@/types/response-data';
import store from '@/store';
import router from '@/router';
import storageObservable from './storageObservable';
import cookie from './cookie';
import CustomError from './Error';

// Сессия истекла: чистим cookie, разлогиниваем все вкладки и уводим на вход
export function logoutUnauthorized() {
    cookie.deleteCookie('PHPSESSID')
    router.push({ name: "login" })
    storageObservable.emit('logout', {
        logout: true
    });
    store.dispatch('logout')
}

export async function $fetch<T>(input: RequestInfo, init?: RequestInit | undefined, formResState?: FormResStatus) {
    if (formResState) {
        formResState.pending = true
        formResState.reset()
    }
    if (init && (init.method === 'post' || init.method === 'POST' || init.method === 'put' || init.method === 'PUT')) {
        if (init.headers) {
            if (!(init.headers as any)['Content-Type'] && (init.headers as any)['Content-Type'] !== '') (init.headers as any)['Content-Type'] = 'application/json'
            else if ((init.headers as any)['Content-Type'] === '') delete (init.headers as any)['Content-Type'];
        }
        else init.headers = {
            'Content-Type': 'application/json'
        }
    }

    return await fetch(input, init)
        .then((res) => {
            if (formResState) formResState.pending = false;
            switch (res.status) {
                case 200:
                    return res.json();
                case 401:
                    logoutUnauthorized()
                    break;
                default:
                    throw new CustomError('Ошибка соединения!', 'Error', res.status)
            }
        })
        .then((data: ResData<T>) => {
            if (data.error) {
                if (formResState) {
                    if (data.errorList) data.errorList.push({
                        target: 'form',
                        msg: data.error
                    }); else data.errorList = new Array({
                        target: 'form',
                        msg: data.error
                    })
                    formResState.setError(data.errorList)
                }
                if (data.status) throw new CustomError(data.error, 'ERR_CONNECTION', data.status)
                else
                    throw new Error(data.error);
            } else return data
        })
        .catch((err: Error) => {
            if (formResState) {
                formResState.pushError({
                    target: 'form',
                    msg: err.message
                })
            }
            throw err
        })
}